module.exports = __webpack_public_path__ + "img/53.bb89f44f.png";